import { createContext } from "react";

const RowContext = createContext({
  standard: null,
  idx: null,
  currentIndex: null,
  inputText: null,
  isEditing: null,
  isCreation: null,

  onInputChange: () => {},
  returnFontStyle: () => {},
  editStandardText: () => {},
  enterKeyPressed: () => {},
  deleteOnClick: () => {},
  indentOnClick: () => {},
  outdentOnClick: () => {},
});

export default RowContext;
